import React, { useState, useRef, useEffect } from "react";
import "./Transactional.css";
import NavbarComponent from "../../components/navbar/NavbarComponent";
import { Link, useNavigate } from "react-router-dom";
import { API } from "../../constants/Api";
import { toast } from "react-toastify";
import Select from "react-select";
import { BorderAllRounded, Height } from "@mui/icons-material";
import { fontFamily, fontSize, padding, textAlign } from "@mui/system";
import zIndex from "@mui/material/styles/zIndex";
import { Button, Flex, Modal } from "antd";
import Meta from "../../components/Meta";
function Transactional() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("login");
  const [agree, setAgree] = useState(false);
  const verifyRef = useRef(null);
  const registerRef = useRef(null);
  const selectRef = useRef(null);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [agentzipCode, setCode] = useState([]);
  const [phonenumber, setPhoneNumber] = useState("");
  const [password, setPassword] = useState("");
  const [image, setImage] = useState("");
  const [loading, setLoading] = useState(false);
  const [emailForVerify, setEmailForVerify] = useState("");
  const [otp, setOtp] = useState("");
  const [emailLogin, setEmailLogin] = useState("");
  const [passwordLogin, setPasswordLogin] = useState("");
  const [file, setFile] = useState(null);
  const [options, setOptions] = useState([
    {
      label: "California",
      value: "California",
    },
  ]);
  const [singInHeading, setHeading] = useState(
    "Welcome Back to Deal Direct Homes"
  );
  const agentId = localStorage.getItem("agentId");

  const token = localStorage.getItem("token");

  const [isDropdownOpen, setIsDropdownOpen] = React.useState(false);
  const [selectedOption, setSelectedOption] = React.useState(
    "Transaction Coordinator"
  );

  useEffect(() => {
    if (token) {
      if (agentId) {
        navigate("/agent-auth/profile");
      }
    }
  }, [token]);
  const handleChangeTab = () => {
    switch (activeTab) {
      case "register":
        return setActiveTab("login");
      case "login":
        return setActiveTab("register");
      default:
        return setActiveTab("register");
    }
  };

  useEffect(() => {
    if (activeTab === "register") {
      if (verifyRef) {
        verifyRef.current.style.display = "none";
      }
    }
  }, [activeTab]);

  // useEffect(() => {
  //   const getOptions = async () => {
  //     try {
  //       const response = await fetch(`${API}/auth/role-check/get-allZipCodes`);
  //       const json = await response.json();

  //       if (response.ok) {
  //         const aqdas = await json.map((data) => ({
  //           label: data.zipCode,
  //           value: data.zipCode,
  //         }));
  //         if (aqdas) {
  //           setOptions(aqdas);
  //         }
  //       }
  //     } catch (error) {
  //       toast.error(error.message);
  //     }
  //   };

  //   getOptions();
  // }, []);

  const colorStyles = {
    control: (base, state) => ({
      ...base,
      backgroundColor: "#252525",
      borderColor: state.isFocused ? "#252525" : "#252525",
      boxShadow: state.isFocused ? "none" : "none",
      borderRadius: "20px", // Adjust the border-radius as needed
      minHeight: "66px", // Increase the height
      padding: "10px",
      "&:hover": {
        borderColor: "#252525",
      },
      "&:focus": {
        borderColor: "#252525",
      },
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? "#24A97B"
        : state.isFocused
          ? "#252525"
          : "#252525",
      borderRadius: "20px",

      color: state.isSelected ? "black" : "white",
      "&:hover": {
        backgroundColor: "#000000",
      },
    }),
    menu: (base) => ({
      ...base,
      backgroundColor: "#252525",
      border: "1px solid #252525",
      borderRadius: "20px", // Add border-radius to the dropdown menu
      fontFamily: "Degular-Light",
      fontSize: "14px",
      padding: "10px",
    }),
    placeholder: (base) => ({
      ...base,
      color: "#ffffff",
      fontFamily: "Degular-Light",
      fontSize: "14px",
      opacity: "0.7",
    }),
    singleValue: (base) => ({
      ...base,
      color: "#ffffff",
      fontFamily: "Degular-Light",
      fontSize: "14px",
    }),
    input: (base) => ({
      ...base,
      color: "#ffffff",
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: "#000000",
      fontFamily: "Degular-Light",
      fontSize: "14px",
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: "#ffffff",
      fontFamily: "Degular-Light",
      fontSize: "14px",
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: "#ffffff",
      "&:hover": {
        backgroundColor: "red",
        color: "white",
      },
    }),
  };

  const handleZipChange = (selectedOption) => {
    setCode(selectedOption ? selectedOption.map((aqdas) => aqdas.value) : []);
  };

  function loginValidation() {
    if (emailLogin.length < 1) {
      toast.error("Email is required");
      return false;
    }
    if (passwordLogin.length < 1) {
      toast.error("Password is required");
      return false;
    }

    return true;
  }
  function otpValidation() {
    if (otp.length < 1) {
      toast.error("OTP is required");
      return false;
    }
    if (!agree) {
      toast.error("You must agree first");
      return false;
    }

    return true;
  }
  function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }
  function validation() {
    if (name.length < 1) {
      toast.error("Name is required");
      return false;
    }

    if (email.length < 1) {
      toast.error("Email is required");
      return false;
    } else {
      if (!isValidEmail(email)) {
        toast.error("Please enter valid email");
        return false;
      }
    }
    if (agentzipCode.length < 1) {
      toast.error("please select state");
      return false;
    }
    if (selectedOption.length < 1) {
      toast.error("Vendor Type is required");
      return false;
    }
    if (phonenumber.length < 1) {
      toast.error("Phone number required");
      return false;
    }
    if (phonenumber.length > 10) {
      toast.error("Phone length should be under 11");
      return false;
    }
    if (password.length < 1) {
      toast.error("Password is required");
      return false;
    }
    if (!agree) {
      toast.error("You must agree first");
      return false;
    }

    return true;
  }

  const handleSignUp = async (e) => {
    e.preventDefault();

    const validate = await validation();

    if (validate) {
      const formData = new FormData();

      formData.append("agentName", name);
      formData.append("agentEmail", email);
      formData.append("agentPhone", phonenumber);
      formData.append("password", password);
      formData.append("state", agentzipCode[0]);
      formData.append("agentVendorType", selectedOption);
      formData.append("file", file);
      setLoading(true);
      const toastLoading = await toast.loading("Creating new agent...");
      try {
        const response = await fetch(`${API}/agents/register-agent`, {
          method: "POST",
          body: formData,
        });
        const json = await response.json();
        if (response.ok) {
          toast.dismiss(toastLoading);
          toast.success("Please check your email to verify your account");
          setLoading(false);
          // setEmailForVerify(json.agent.agentEmail);

          // if (registerRef) {
          //   registerRef.current.style.display = "none";
          // }
          // if (verifyRef) {
          //   verifyRef.current.style.display = "block";
          // }
          setName("");
          setEmail("");
          setPassword("");
          setPhoneNumber("");
          setOtp("");
          setHeading("Once verified, you can login");
          handleChangeTab();
        } else {
          setLoading(false);
          toast.dismiss(toastLoading);
          toast.error(json.message);
        }
      } catch (error) {
        toast.error(error.message);
      } finally {
        setLoading(false);
        toast.dismiss(toastLoading);
      }
    }
  };
  const handleVerify = async (e) => {
    e.preventDefault();

    const validate = await otpValidation();

    if (validate) {
      const data = {
        agentEmail: emailForVerify,
        otp,
      };
      try {
        setLoading(true);
        const toastLoading = await toast.loading("OTP verifying...");
        const response = await fetch(`${API}/agents/verify-agent-otp`, {
          method: "POST",
          body: JSON.stringify(data),
          headers: {
            "Content-Type": "application/json",
          },
        });
        const json = await response.json();
        if (response.ok) {
          toast.dismiss(toastLoading);
          toast.success("User verified successfully");
          setLoading(false);
          setName("");
          setEmail("");
          setPassword("");
          setPhoneNumber("");
          setOtp("");
          setHeading("You've created account, now login");
          handleChangeTab();
        } else {
          setLoading(false);
          toast.dismiss(toastLoading);
          toast.error(json.message);
        }
      } catch (error) {
        toast.error(error.message);
      } finally {
        setLoading(false);
      }
    }
  };
  const handleLogin = async (e) => {
    e.preventDefault();

    const validate = await loginValidation();

    if (validate) {
      const data = {
        agentEmail: emailLogin,
        agentPassword: passwordLogin,
        agentVendorType: "Transaction Coordinator",
      };
      setLoading(true);
      const toastLoading = toast.loading("Signing in...");
      try {
        const response = await fetch(`${API}/agents/login-agent`, {
          method: "POST",
          body: JSON.stringify(data),
          headers: {
            "Content-Type": "application/json",
          },
        });
        const json = await response.json();
        if (response.ok) {
          toast.dismiss(toastLoading);
          toast.success("Signed in successfully");
          setLoading(false);
          await localStorage.removeItem("token");
          await localStorage.removeItem("laId");
          await localStorage.removeItem("laEmail");
          await localStorage.removeItem("laName");
          await localStorage.removeItem("laPhone");
          await localStorage.removeItem("laState");
          await localStorage.removeItem("token");
          await localStorage.removeItem("agentId");
          await localStorage.removeItem("agentEmail");
          await localStorage.removeItem("agentName");
          await localStorage.removeItem("agentPhone");

          await localStorage.removeItem("agentVendorType");
          await localStorage.removeItem("agentState");
          await localStorage.removeItem("agentZipCode");

          await localStorage.removeItem("token");
          await localStorage.removeItem("userId");
          await localStorage.removeItem("userEmail");
          await localStorage.removeItem("userName");
          await localStorage.removeItem("userPhone");
          await localStorage.removeItem("userZipCode");

          await localStorage.removeItem("token");
          await localStorage.removeItem("advertiserId");
          await localStorage.removeItem("email");
          await localStorage.removeItem("name");
          await localStorage.removeItem("phone");
          await localStorage.removeItem("zipCode");

          await localStorage.removeItem("token");
          await localStorage.removeItem("adminId");
          await localStorage.removeItem("adminEmail");
          await localStorage.removeItem("adminName");
          await localStorage.removeItem("adminPhone");
          await localStorage.removeItem("token");
          await localStorage.removeItem("addhypeId");
          await localStorage.removeItem("addhypeEmail");
          await localStorage.removeItem("addhypeName");
          await localStorage.removeItem("addhypePhone");
          localStorage.setItem("token", json.token);
          localStorage.setItem("agentId", json.agent._id);
          localStorage.setItem("agentEmail", json.agent.agentEmail);
          localStorage.setItem("agentName", json.agent.agentName);
          localStorage.setItem("agentPhone", json.agent.agentPhone);
          localStorage.setItem("agentState", json.agent.state);
          localStorage.setItem("agentVendorType", json.agent.agentVendorType);
          navigate("/agent-auth/profile");
          setEmailLogin("");
          setPasswordLogin("");
        } else {
          setLoading(false);
          toast.dismiss(toastLoading);
          toast.error(json.message);
        }
      } catch (error) {
        toast.dismiss(toastLoading);
        toast.error(error.message);
      } finally {
        setLoading(false);
      }
    }
  };

  const [openResponsive, setOpenResponsive] = useState(false);

  const openTerms = () => {
    setOpenResponsive(true);
  };
  const handleForgot = (e) => {
    e.preventDefault();
    navigate("/forgot-password", { state: { type: "tc" } });
  };
    const [isMobile, setIsMobile] = useState(false);
    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth <= 600);
      };
  
      handleResize();
  
      window.addEventListener("resize", handleResize);
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }, []);
  return (
    <>
      <Meta
        title="Transaction Coordinator Sign Up | DDH"
        description="Sign up as a transaction coordinator on Deal Direct Homes to assist agents and clients with seamless home buying transactions."
      />
      <div className="agent-register-section">
        <NavbarComponent />
        {activeTab === "register" ? (
          <div className="container-fluid agent-register-container px-0">
            <div className="row px-0 mx-0">
              <div className="col-lg-6 agent-register-form-conatiner">
                <span ref={registerRef} className="w-100">
                  <h2 className="agent-register-heading">
                    Join as a Transaction Coordinator
                  </h2>
                  <div className="my-2">
                    <button
                      className="btn agent-login-register-tab"
                      onClick={handleChangeTab}
                    >
                      Sign In
                    </button>
                    <button className="btn agent-login-register-tab ms-3 active-agent-login-register-tab">
                      Register
                    </button>
                  </div>
                  <form className="agent-register-form">
                    <input
                      type="text"
                      className="form-control agent-register-input-field"
                      id="exampleInputEmail1"
                      placeholder="Full Name"
                      aria-describedby="emailHelp"
                      onChange={(e) => setName(e.target.value)}
                    />

                    <input
                      type="email"
                      className="form-control agent-register-input-field"
                      id="exampleInputPassword1"
                      placeholder="Email"
                      onChange={(e) => setEmail(e.target.value)}
                    />
                        {isMobile ? (
                      <input
                        type="tel"
                        className="form-control agent-register-input-field"
                        id="userPhone"
                        placeholder="Phone number"
                        value={`+1 ${phonenumber}`} // Display "+1" prefix
                        onChange={(e) => {
                          // Remove "+1" and any extra spaces before saving to state
                          const rawNumber = e.target.value
                            .replace(/^\+1\s*/, "")
                            .slice(0, 10);
                          setPhoneNumber(rawNumber);
                        }}
                      />
                    ) : (
                      <div className="agent-register-phone-number-group">
                        <button disabled className="agent-register-phone-code">
                          +1
                        </button>
                        <input
                          type="number"
                          className="form-control agent-register-phone-field"
                          id="exampleInputPassword1"
                          placeholder="Phone Number"
                          maxLength="10"
                          min="0"
                          max="9999999999"
                          pattern="\d*"
                          onChange={(e) => {
                            const value = e.target.value
                              .replace(/\D/g, "")
                              .slice(0, 10);
                            setPhoneNumber(value);
                            e.target.value = value;
                          }}
                        />
                      </div>
                    )}

                    <input
                      type="password"
                      className={`form-control agent-register-input-field ${isMobile ? "" : "pass-input"}`}
                      id="exampleInputPassword1"
                      placeholder="Password"
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <hr
                      className="text-white agent-register-devider-1"
                      style={{ opacity: "0.1" }}
                    />
                    {/* <input
                    type="number"
                    className="form-control agent-register-input-field"
                    id="exampleInputPassword1"
                    placeholder="Zip Code"
                    onChange={(e) => setCode(e.target.value)}
                  /> */}

                    <div onClick={() => setIsDropdownOpen(false)}>
                      <Select
                        isMulti
                        name="colors"
                        styles={colorStyles}
                        options={options}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        placeholder="Choose State..."
                        onChange={handleZipChange}
                      />
                    </div>
                    <div className="mb-3 form-check agent-register-verify-check-group px-0">
                      <img
                        role="button"
                        onClick={() => setAgree(!agree)}
                        src={`${agree ? "/img/checked.svg" : "/img/uncheck.svg"}`}
                        className="img-fluid"
                        alt=""
                      />

                      <label
                        className="form-check-label ms-3"
                        htmlFor="exampleCheck1"
                      >
                        I agree to the{" "}
                        <b
                          className="text-white"
                          onClick={openTerms}
                          role="button"
                        >
                          Terms and Conditions
                        </b>{" "}
                        set by DDH
                      </label>
                      <Modal
                        style={{ padding: "0px", margin: "0px" }}
                        centered
                        open={openResponsive}
                        footer={null}
                        closable={false}
                        width={{
                          xs: "90%",
                          sm: "80%",
                          md: "65%",
                          lg: "60%",
                          xl: "60%",
                          xxl: "60%",
                        }}
                      >
                        <div className="container-fluid pop-up-terms">
                          <img
                            src="/img/pop-up-close.svg"
                            className="img-fluid pop-up-close"
                            onClick={() => setOpenResponsive(false)}
                            role="button"
                            alt=""
                          />
                          <div className="container-fluid">
                            <div className="row">
                              <div className="col-12 agreement-1st-container">
                                <h2 className="agreement-heading">
                                  Transaction Coordinator Service Agreement
                                </h2>
                                <p className="agreement-paragraph">
                                  By clicking the agree button, you agree to the
                                  following: This agreement is between Deal
                                  Direct Homes LLC, hereinto, referred to as
                                  DDH, and the Transaction Coordinator, hereinto
                                  referred to as TC. It is preferred that all
                                  TC’s maintain a valid DRE License and at the
                                  minimum a State Business License to buy leads
                                  from DDH. TC wishes to buy Buyer Leads for the
                                  opportunity to perform Transaction Services
                                  per this agreement. Buyer Leads that are
                                  distributed by DDH are not to pay for any
                                  Agent Commission unless explicitly disclosed
                                  and consulted in signing of Buyer Agent
                                  Agreement. TC’s will handle all documents from
                                  Offer to Post-Closing.
                                </p>

                                <h2 className="agreement-heading">
                                  Transaction Service to Include Recital
                                </h2>
                                <p className="agreement-paragraph">
                                  It is the intent of DDH to provide leads,
                                  hereinto referred to as Client, that wish to
                                  self-represent and need Contract and Purchase
                                  assistance from a Professional Transaction
                                  Coordinator. Thus, all fees charged by the
                                  Transaction Coordinator are collected from the
                                  client and paid up front whether any purchase
                                  is concluded. TC’s must verify the subject
                                  property is still available for purchase and
                                  the client is un-represented. In addition, the
                                  use of our Preferred Service Providers is
                                  essential.
                                  <ol>
                                    <li className="mt-2">
                                      Verify Listing and enter Listing Agent
                                      information into your TC Portal in Deal
                                      Direct Homes.com
                                    </li>
                                    <li className="mt-2">
                                      Prepare Contract Per Clients Instructions
                                      Including counters
                                    </li>
                                    <li className="mt-2">
                                      Review and Prepare Any Addendums
                                    </li>
                                    <li className="mt-2">
                                      Make Self-Represented Offer To Listing
                                      Agent on behalf Of The Client
                                    </li>
                                    <li className="mt-2">Open Escrow</li>
                                    <li className="mt-2">
                                      Prepare and Follow Timelines For The
                                      Client
                                    </li>
                                    <li className="mt-2">
                                      Provide All Necessary Forms For Clients
                                      Use
                                    </li>
                                    <li className="mt-2">
                                      Order Inspections and Reports
                                    </li>
                                    <li className="mt-2">
                                      Copy of Completed File Available to Client
                                      (if requested).
                                    </li>
                                    <li className="mt-2">
                                      Any Other Requested Tasks Agreed Upon With
                                      Client In Advance
                                    </li>
                                  </ol>
                                  Lead Cost: $99.00 Subject to change at any
                                  time. Prompt contact is essential. <br />
                                  Best Practices: Charge up to $498.00 (max) for
                                  up to 3 offers, $49.00 for each additional
                                  offer. Or Charge $198.00 per offer. <br />
                                  It is DDH’s goal to have each Transaction
                                  Coordinator deliver service focused on the
                                  individual Client/s. DDH maintains a master
                                  list of recommended Service Providers for each
                                  Zip Code. The master list will be distributed
                                  after each lead purchase and Transaction
                                  Coordinators are encouraged to use and refer
                                  Service Providers in each category.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Modal>
                    </div>
                    {loading ? (
                      <span className="btn agent-register-button">
                        Processing...
                      </span>
                    ) : (
                      <button
                        onClick={handleSignUp}
                        className="btn agent-register-button"
                      >
                        Sign Up
                      </button>
                    )}

                    {/* <img
                    src="/img/user-register-devider.svg"
                    className="img-fluid agent-register-devider"
                    alt=""
                  />
                  <button
                    type="button"
                    className="btn agent-register-google-button"
                  >
                    <img src="/img/google.png" alt="" /> Continue with Google
                  </button> */}
                  </form>
                </span>
                <span ref={verifyRef} className="w-100">
                  <h2 className="agent-register-heading code-veri-heading">
                    Verify Account
                  </h2>

                  <form className="agent-register-form code-veri-input">
                    <input
                      type="number"
                      className="form-control agent-register-input-field"
                      id="exampleInputEmail1"
                      placeholder="00 00"
                      aria-describedby="emailHelp"
                      onChange={(e) => setOtp(e.target.value)}
                    />

                    <label style={{ opacity: "0.8" }} className="code-label">
                      4 - Digit code has been sent to your phone number and
                      email.{" "}
                      {/* <Link className="text-white">Change Details</Link> */}
                    </label>

                    <label className="code-label" style={{ opacity: "0.7" }}>
                      By clicking the agree button, you agree to the following:
                      This agreement is between Deal Direct Home LLC, hereinto
                      referred to as DDH, and the Transaction Coordinator,
                      hereinto referred to as TC. It is preferred that all TC’s
                      maintain a valid DRE License to buy leads from DDH.
                    </label>

                    <div className="mb-3 form-check agent-register-verify-check-group px-0">
                      <img
                        role="button"
                        onClick={() => setAgree(!agree)}
                        src={`${agree ? "/img/checked.svg" : "/img/uncheck.svg"}`}
                        className="img-fluid"
                        alt=""
                      />

                      <label
                        className="form-check-label ms-3"
                        htmlFor="exampleCheck1"
                      >
                        I agree to the{" "}
                        <b
                          className="text-white"
                          onClick={openTerms}
                          role="button"
                        >
                          Terms and Conditions
                        </b>{" "}
                        set by DDH
                      </label>
                      <Modal
                        style={{ padding: "0px", margin: "0px" }}
                        centered
                        open={openResponsive}
                        footer={null}
                        closable={false}
                        width={{
                          xs: "90%",
                          sm: "80%",
                          md: "65%",
                          lg: "60%",
                          xl: "60%",
                          xxl: "60%",
                        }}
                      >
                        <div className="container-fluid pop-up-terms">
                          <img
                            src="/img/pop-up-close.svg"
                            className="img-fluid pop-up-close"
                            onClick={() => setOpenResponsive(false)}
                            role="button"
                            alt=""
                          />
                          <div className="container-fluid">
                            <div className="row">
                              <div className="col-12 agreement-1st-container">
                                <h2 className="agreement-heading">
                                  Transaction Coordinator Service Agreement
                                </h2>
                                <p className="agreement-paragraph">
                                  By clicking the agree button, you agree to the
                                  following: This agreement is between Deal
                                  Direct Homes LLC, hereinto, referred to as
                                  DDH, and the Transaction Coordinator, hereinto
                                  referred to as TC. It is preferred that all
                                  TC’s maintain a valid DRE License and at the
                                  minimum a State Business License to buy leads
                                  from DDH. TC wishes to buy Buyer Leads for the
                                  opportunity to perform Transaction Services
                                  per this agreement. Buyer Leads that are
                                  distributed by DDH are not to pay for any
                                  Agent Commission unless explicitly disclosed
                                  and consulted in signing of Buyer Agent
                                  Agreement. TC’s will handle all documents from
                                  Offer to Post-Closing.
                                </p>

                                <h2 className="agreement-heading">
                                  Transaction Service to Include Recital
                                </h2>
                                <p className="agreement-paragraph">
                                  It is the intent of DDH to provide leads,
                                  hereinto referred to as Client, that wish to
                                  self-represent and need Contract and Purchase
                                  assistance from a Professional Transaction
                                  Coordinator. Thus, all fees charged by the
                                  Transaction Coordinator are collected from the
                                  client and paid up front whether any purchase
                                  is concluded. TC’s must verify the subject
                                  property is still available for purchase and
                                  the client is un-represented. In addition, the
                                  use of our Preferred Service Providers is
                                  essential.
                                  <ol>
                                    <li className="mt-2">
                                      Verify Listing and enter Listing Agent
                                      information into your TC Portal in Deal
                                      Direct Homes.com
                                    </li>
                                    <li className="mt-2">
                                      Prepare Contract Per Clients Instructions
                                      Including counters
                                    </li>
                                    <li className="mt-2">
                                      Review and Prepare Any Addendums
                                    </li>
                                    <li className="mt-2">
                                      Make Self-Represented Offer To Listing
                                      Agent on behalf Of The Client
                                    </li>
                                    <li className="mt-2">Open Escrow</li>
                                    <li className="mt-2">
                                      Prepare and Follow Timelines For The
                                      Client
                                    </li>
                                    <li className="mt-2">
                                      Provide All Necessary Forms For Clients
                                      Use
                                    </li>
                                    <li className="mt-2">
                                      Order Inspections and Reports
                                    </li>
                                    <li className="mt-2">
                                      Copy of Completed File Available to Client
                                      (if requested).
                                    </li>
                                    <li className="mt-2">
                                      Any Other Requested Tasks Agreed Upon With
                                      Client In Advance
                                    </li>
                                  </ol>
                                  Lead Cost: $99.00 Subject to change at any
                                  time. Prompt contact is essential. <br />
                                  Best Practices: Charge up to $498.00 (max) for
                                  up to 3 offers, $49.00 for each additional
                                  offer. Or Charge $198.00 per offer. <br />
                                  It is DDH’s goal to have each Transaction
                                  Coordinator deliver service focused on the
                                  individual Client/s. DDH maintains a master
                                  list of recommended Service Providers for each
                                  Zip Code. The master list will be distributed
                                  after each lead purchase and Transaction
                                  Coordinators are encouraged to use and refer
                                  Service Providers in each category.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Modal>
                    </div>
                    {loading ? (
                      <span className="btn veri-button">Verifying...</span>
                    ) : (
                      <button
                        onClick={handleVerify}
                        className="btn veri-button"
                      >
                        Verify
                      </button>
                    )}
                  </form>
                </span>
              </div>
              <div className="col-lg-6 px-0 d-none d-lg-block">
                <div className="tc-register-image-conatiner"></div>
              </div>
            </div>
          </div>
        ) : (
          <div className="container-fluid agent-register-container px-0">
            <div className="row px-0 mx-0">
              <div className="col-lg-6 agent-register-form-conatiner">
                <h2 className="agent-register-heading">{singInHeading}</h2>
                <div className="my-2">
                  <button className="btn agent-login-register-tab active-agent-login-register-tab">
                    Sign In
                  </button>
                  <button
                    className="btn agent-login-register-tab ms-3"
                    onClick={handleChangeTab}
                  >
                    Register
                  </button>
                </div>
                <form className="agent-register-form">
                  <input
                    type="email"
                    className="form-control agent-register-input-field"
                    id="exampleInputPassword1"
                    placeholder="Email"
                    onChange={(e) => setEmailLogin(e.target.value)}
                    value={emailLogin}
                  />

                  <input
                    type="password"
                    className="form-control agent-register-input-field"
                    id="exampleInputPassword1"
                    placeholder="Password"
                    onChange={(e) => setPasswordLogin(e.target.value)}
                    value={passwordLogin}
                  />
                  <p
                    onClick={handleForgot}
                    style={{ cursor: "pointer", lineHeight: "1px" }}
                    className="forgot-password-button mt-4"
                  >
                    Forgot Password?
                  </p>
                  <button
                    onClick={handleLogin}
                    className="btn agent-register-button"
                  >
                    Sign In
                  </button>
                  {/* <img
                  src="/img/agent-register-devider.svg"
                  className="img-fluid agent-register-devider"
                  alt=""
                />
                <button
                  type="button"
                  className="btn agent-register-google-button"
                >
                  <img src="/img/google.png" alt="" /> Continue with Google
                </button> */}
                </form>
              </div>
              <div className="col-lg-6 px-0 d-none d-lg-block">
                <div className="tc-signin-image-conatiner"></div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default Transactional;
